export const columnDetails={
    column1:{
        header: '',
        accessor: 'merchantName',
    },
    column2:{
        header:'',
        accessor: 'freechargeMid',
    },
    column3:{
        header:'Approve',
        accessor: 'action1',
    },
    column4:{
        header:'Reject',
        accessor: 'action2',
    },
    column5:{
        header:'Remarks',
        accessor: 'action3',
    }

}

export const REJECT = 'REJECT';
export const APPROVE = 'APPROVE';
export const SUBMIT_CHECKER = 'SUBMIT_CHECKER';

// Address - Pin Code, District, State, Address

// Pan Details - Legal Name, Pan Upload, Pan Number, Pan Name, Date of Incorporation

// GST - Gst Upload and GST Name

// Turnover - Turnover Category + Turnover Amount
export const PAN_CLUB_KEY = 'pan_club_key';
export const ADDRESS_CLUB_KEY = 'address_club_key';
export const GST_CLUB_KEY = 'gst_club_key';
export const TURNOVER_CLUB_KEY = 'turnover_club_key';
export const PROOF_OF_ADDRESS_CLUB_KEY = 'proof_of_address_club_key';

export const ACCOUNT_CLUB_KEY = 'account_club_key';
export const MCC_CLUB_KEY="mcc_club_key";

export const PREFIX_KYCURLS = 'kycDocUrls';

export const REMOVE_MLE_CLUBBING_FOR_UPDATE=["panDetails.url","panDetails.panNumber","dateOfIncorporation","addressProofUrls","addressProof", "panDetails.dob"]